/**
 * Namespaced localStorage wrapper to prevent key collisions
 * between partner-nxt-web and other apps on the same origin.
 */
const PREFIX = "pw_";

const storage = {
  get(key: string): string | null {
    return localStorage.getItem(PREFIX + key);
  },
  set(key: string, value: string): void {
    localStorage.setItem(PREFIX + key, value);
  },
  remove(key: string): void {
    localStorage.removeItem(PREFIX + key);
  },
  /** Migrate bare keys → prefixed keys (run once on app init) */
  migrate(): void {
    const authKeys = ["token", "name", "emailID", "userID", "role", "isLogin", "profileImage", "accountType", "mobileNumber", "partnerID"];
    for (const key of authKeys) {
      const bare = localStorage.getItem(key);
      const prefixed = localStorage.getItem(PREFIX + key);
      if (bare && !prefixed) {
        localStorage.setItem(PREFIX + key, bare);
        localStorage.removeItem(key);
      }
    }
  },
};

export default storage;
